import {
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightAddon,
} from "@chakra-ui/react";

function InputField({
  leftAddOn,
  rightAddOn,
  ...props
}: {
  leftAddOn?: string | React.ReactNode;
  rightAddOn?: string | React.ReactNode;
  [key: string]: unknown;
}) {
  return (
    <InputGroup size="md">
      {leftAddOn && <InputLeftAddon>{leftAddOn}</InputLeftAddon>}
      <Input {...props} />
      {rightAddOn && <InputRightAddon>{rightAddOn}</InputRightAddon>}
    </InputGroup>
  );
}

export default InputField;
